export default "__VITE_PUBLIC_ASSET__a13559a3__"